import api from './api';

export const generateKOT = async (orderId,user) => {
  try {
      const response = await api.post(`/vendor/orders/${orderId}/kot`);
      const kotData = response.data.data;
      // Open print window
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>KOT - ${kotData.orderNumber}</title>
            <style>
              @media print {
                @page { margin: 0; size: 80mm auto; }
                body { margin: 0; }
              }
              * { margin: 0; padding: 0; box-sizing: border-box; }
              body { 
                font-family: 'Courier New', monospace; 
                width: 80mm;
                padding: 5mm;
                font-size: 12px;
                line-height: 1.4;
              }
              .header {
                text-align: center;
                border-bottom: 2px dashed #000;
                padding-bottom: 8px;
                margin-bottom: 10px;
              }
              .header img.logo {
                width: 60px;
                height: 60px;
                object-fit: contain;
                margin-bottom: 8px;
                border-radius: 8px;
              }
              .header h2 {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 4px;
                letter-spacing: 1px;
              }
              .header .restaurant {
                font-size: 11px;
                margin-bottom: 2px;
              }
              .order-info {
                margin: 10px 0;
                border-bottom: 1px dashed #000;
                padding-bottom: 8px;
              }
              .order-info div {
                display: flex;
                justify-content: space-between;
                margin: 3px 0;
                font-size: 11px;
              }
              .order-info .label { font-weight: bold; }
              .items-section {
                margin: 10px 0;
              }
              .items-header {
                display: flex;
                justify-content: space-between;
                border-bottom: 2px solid #000;
                padding: 5px 0;
                font-weight: bold;
                font-size: 11px;
              }
              .item-row {
                display: flex;
                justify-content: space-between;
                padding: 0;
                border-bottom: 1px dashed #ccc;
              }
              .item-name {
                flex: 1;
                font-weight: bold;
                font-size: 12px;
              }
              .item-qty {
                width: 40px;
                text-align: center;
                font-size: 14px;
                font-weight: bold;
              }
              .item-notes {
                font-size: 10px;
                color: #555;
                margin-top: 2px;
                padding-left: 5px;
              }
              .offer-section {
                margin: 8px 0;
                padding: 8px;
                background: #f8f9fa;
                border-left: 3px solid #28a745;
                border-radius: 4px;
              }
              .offer-title {
                font-size: 10px;
                color: #28a745;
                font-weight: bold;
                margin-bottom: 4px;
                text-transform: uppercase;
                letter-spacing: 0.5px;
              }
              .free-items {
                margin-top: 4px;
                padding-top: 4px;
                border-top: 1px dashed #28a745;
              }
              .free-item-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 2px 0;
                font-size: 11px;
              }
              .free-item-name {
                color: #6c757d;
                font-style: italic;
              }
              .free-item-qty {
                color: #28a745;
                font-weight: bold;
              }
              .special-instructions {
                margin: 10px 0;
                padding: 8px;
                background: #f5f5f5;
                border: 1px solid #ddd;
                border-radius: 4px;
              }
              .special-instructions strong {
                display: block;
                margin-bottom: 4px;
                font-size: 11px;
              }
              .special-instructions p {
                font-size: 11px;
                line-height: 1.3;
              }
              .footer {
                text-align: center;
                margin-top: 15px;
                padding-top: 10px;
                border-top: 2px dashed #000;
                font-size: 11px;
              }
            </style>
          </head>
          <body>
            <div class="header">
              <h2>*** KOT ***</h2>
              ${user?.restaurantLogo ? `<img src="${user?.restaurantLogo}" alt="Logo" class="logo">` : ''}
              <div class="restaurant">${kotData.restaurantName}</div>
            </div>
            
            <div class="order-info">
              <div><span class="label">Order #:</span><span>${kotData.orderNumber}</span></div>
              <div><span class="label">Table:</span><span>${kotData.tableNumber}</span></div>
              <div><span class="label">Type:</span><span>${kotData.orderType ? kotData.orderType.replace('-', ' ').toUpperCase() : 'DINE IN'}</span></div>
              <div><span class="label">Customer:</span><span>${kotData.customerName}</span></div>
              <div><span class="label">Time:</span><span>${new Date(kotData.orderTime).toLocaleTimeString()}</span></div>
            </div>
            
            <div class="items-section">
              <div class="items-header">
                <span>ITEM</span>
                <span>QTY</span>
              </div>
              ${kotData.items.map(item => `
                <div class="item-row">
                  <div style="flex: 1;">
                    <div class="item-name">${item.name}</div>
                    ${item.customizations && item.customizations.length > 0 ? `<div class="item-notes">Note: ${Array.isArray(item.customizations) ? item.customizations.join(', ') : item.customizations}</div>` : ''}
                    ${item.bogoApplied && item.bogoDetails ? `
                      <div class="offer-section">
                        <div class="offer-title">Offer Applied: ${item.bogoDetails.offerText || 'Buy 1 Get 1 Free'}</div>
                        ${item.freeItems && item.freeItems.length > 0 ? `
                          <div class="free-items">
                            ${item.freeItems.map(freeItem => `
                              <div class="free-item-row">
                                <span class="free-item-name">${freeItem.name}</span>
                                <span class="free-item-qty">${freeItem.quantity}x</span>
                              </div>
                            `).join('')}
                          </div>
                        ` : ''}
                      </div>
                    ` : ''}
                  </div>
                  <div class="item-qty">${item.quantity}x</div>
                </div>
              `).join('')}
            </div>
            
            ${kotData.specialInstructions ? `
              <div class="special-instructions">
                <strong>⚠ SPECIAL INSTRUCTIONS:</strong>
                <p>${kotData.specialInstructions}</p>
              </div>
            ` : ''}
            
            <div class="footer">
              <p>━━━━━━━━━━━━━━━━━━━━</p>
              <p style="margin-top: 5px;">${kotData.orderType ? kotData.orderType.replace('-', ' ').toUpperCase() : 'DINE IN'}</p>
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    //   toast.success('KOT generated');
    } catch (error) {
    //   toast.error('Failed to generate KOT');
    }
};
